module.exports = __webpack_public_path__ + "static/media/moons_advanced-960.676c74df.jpg";